// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-header {
    width: 100%;
    height: 4.5rem;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    background: #0d0d0f;
    border-bottom: 1px solid #1a1a20;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
    padding: 0 1rem;
    z-index: 5;
  }

  main {
    margin-top: 6rem;
  }

  @media (min-width: 768px) {
    .main-header {
      justify-content: space-between;
    }
  }`, "",{"version":3,"sources":["webpack://./src/shared/components/Navigation/MainHeader.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,mBAAmB;IACnB,gCAAgC;IAChC,yCAAyC;IACzC,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE;MACE,8BAA8B;IAChC;EACF","sourcesContent":[".main-header {\n    width: 100%;\n    height: 4.5rem;\n    display: flex;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background: #0d0d0f;\n    border-bottom: 1px solid #1a1a20;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);\n    padding: 0 1rem;\n    z-index: 5;\n  }\n\n  main {\n    margin-top: 6rem;\n  }\n\n  @media (min-width: 768px) {\n    .main-header {\n      justify-content: space-between;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
